import React from 'react';

const H2 = props => <h2 className={'ds-h2'} {...props}>{props.children}</h2>;

export default H2; 